import { cn } from '@lyearn/style';

import { GroupImageClassOverries } from '../../views/GroupManager/types';
import { imageBorderStyles, largeUserAbsolutePictureStyles } from './styles';

export const IMAGE_CLASS_OVERRIDES = {
  userCollection: {
    root: 'w-24 h-24',
    firstPicture: 'w-16 h-16 bg-s-info-light text-s-info-light',
    firstPictureSize: 16,
    secondPicture: cn(
      'w-18 h-18 absolute border border-text-white group-hover:border-bg-secondary bg-s-info-light text-s-info-light',
      largeUserAbsolutePictureStyles,
    ),
    secondPictureSize: 18,
  },
  contentCollection: {
    root: 'w-24 h-24',
    firstPicture: cn(
      imageBorderStyles,
      'absolute top-0 start-0 w-18 h-18 bg-s-info-light rounded-4',
    ),
    firstPictureSize: 18,
    secondPicture: cn(
      imageBorderStyles,
      'w-18 h-18 absolute start-6 top-6 group-hover:border-bg-secondary bg-s-info-light rounded-4',
    ),
    secondPictureSize: 18,
  },
} as GroupImageClassOverries;
